module.exports = __webpack_public_path__ + "img/step35_a_put_the_pocket.c64e9d5a.png";